import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";
import { Buffer } from "buffer";
import React, { Component } from "react";
import FileViewer from "react-file-viewer";
import { ValidatorForm } from "react-material-ui-form-validator";
import "react-tabs/style/react-tabs.css";
import FetchServerData from "../../../provider/FetchServerData";
import {
  CheckTollFreePurchaseVerificationStatus_Url,
  DeleteTollFreeNumber_Url,
  GetCampaigningInfo_Url,
  PurchaseTollFreeNumber_Url,
  TwilioNumberList_Url,
  UpdateCampaigningInfo_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import store from "../../../redux/store";
import { withRouter } from "../../../withRouter";
import CancelIconButton from "../buttons/CancelIconButton";
// import InfoTooltip from "../infoTooltip/InfoTooltip";
import PtsAlert from "../ptsAlert/PtsAlert";
import "./CampaignInformation.css";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
class CampaignInformation extends Component {
  countryListArray = store.getState().staticData.countryList;
  messageTypeList = store.getState().staticData.messageTypeList;
  optinCollectionOptionList =
    store.getState().staticData.optinCollectionOptionList;
  optinPermissonMethodList =
    store.getState().staticData.optinPermissonMethodList;
  organizationTypeList = store.getState().staticData.organizationTypeList;
  sendMessageTypeList = store.getState().staticData.sendMessageTypeList;
  header = store.getState().header.header;
  tollfreeNumberPurchased =
    store.getState().appUserData.appUserData.isTollfreeNumberPurchased;
  tollFreeNumberError =
    store.getState().appUserData.appUserData.tollFreeNumberError;
  crmIntegration = store.getState().crmIntegration.crmIntegration;
  organization = store.getState().appUserData?.organizationDetails;

  constructor(props) {
    super(props);
    let action = props.action;
    let useCaseId = "";
    if (!action && props.state) {
      action = props.state.action;
      useCaseId = props.state.useCaseId;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(action, "view")
    ) {
      this.getCampaignDetails();
      this.getCampaigningInfomsStatic();
    }

    this.state = {
      selectedTab: 0,
      sendTextCanada: "",
      showPassword: false,
      messageType: null,
      messageTypes: [],
      organizationTypeList: [],
      campaignDescription: "",
      keyword: "",
      usecaseText: "",
      sampleText1: "",
      sampleText2: "",
      optInPermissionMethod: [],
      textPerMonth: "",
      sendMessageType: null,
      messageTemplate1: null,
      messageTemplate2: null,
      businessTypeList: [],
      planCategoryList: [],
      selectedTabColor: "#eac891",
      planList: [],
      messageType: null,
      optionPermissionLink: "",
      id: useCaseId,
      action: action,
      showLinkTextFile: false,
      viewSendTextCanad: "",
      showFileView: false,
      render: false,
      optInPermissionMethodList: [],
      viewOptInPermissionMethod: [],
      useCaseList: [],
      messageTemplateList: [],
      messageTemplateListAll: [],
      selectedFile: { name: "" },
      fileName: "",
      tollFreeNumberList: [],
      tollFreeType: null,
      tollfreeNumber: "",
      tollFreeTypeList: [
        {
          type: "Tollfree",
          id: 1,
        },
      ],
      tollFreeNumbers: [],
      twilioNumber: null,
      businessUseCase: null,
      viewTwilioNumber: false,
      addTwilioNumber: false,
      showAddToTollFreeNumber: false,
      tollFreeNumberId: "",
      showDeleteButton: false,
      showPurchaseButton: false,
      showVerificationButton: false,
      showCheckStatusButton: false,
      showErrorMessage: false,
      tollfreeRequestSubmitted: false,
      getUpdatePermission: false,
      isEmailRequest: false,
      isOnlineForm: false,
      onlineFormUrl: null,
      isOnlineCheckout: false,
      onlineCheckoutUrl: null,
      isTextKeyword: false,
      emailDocUrl: null,
      keywordDocUrl: null,
      useCaseTemplate: null,
      showEmailDoc: false,
      showKeywordDoc: false,
    };
  }

  getCampaigningInfomsStatic() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService("/campaigningInfoms/getStatic", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          const messageTypes = output.data.messageTypes?.filter((item) => item?.isActive) || [];

          // if (messageTypes.length > 0) {
          //   this.getIndividualMsgType(messageTypes[0]);
          // }

          this.setState({
            messageTypes: messageTypes,
            // messageType: messageTypes[0],
          });
        }
      });
  }

  getIndividualMsgType(messageType, campaigningInfoDetails, action) {
    const postObject = {
      header: this.header,
      messageType: {
        id: messageType?.id,
      },
    };

    FetchServerData.callPostService("/sendmsgtypems/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          const messageTypeData = output.data.messageType;
          const useCases = messageTypeData?.useCases?.filter((item) => item?.isActive) || [];
          const sampleTexts = useCases?.[0]?.sampleTexts?.filter((item) => item?.isActive) || [];

          const selectedUseCase = useCases.find(
            (item) => item?.usecaseName === campaigningInfoDetails?.usecase
          );
          const sampleMessageTemplate = {
            title: "I will enter my own sample below.",
            messageText: "",
            id: "sample_default",
          };
          const updatedMessageTemplateList = [
            ...sampleTexts,
            sampleMessageTemplate,
          ];
          const lastTemplate = updatedMessageTemplateList[updatedMessageTemplateList.length - 1];
          if (action === "view") {
            this.setState({
              render: true,
              messageType: messageTypeData,
              useCaseList: useCases,
              messageTemplateList: updatedMessageTemplateList,
              messageTemplateListAll: updatedMessageTemplateList,
              useCaseTemplate: selectedUseCase,
            });
          } else {
            this.setState({
              render: true,
              messageType: messageTypeData,
              useCaseList: useCases,
              useCaseTemplate: useCases?.[0],
              usecase: useCases?.[0]?.usecaseName,
              usecaseText: useCases?.[0]?.usecaseText,
              messageTemplateList: updatedMessageTemplateList,
              messageTemplateListAll: updatedMessageTemplateList,
              messageTemplate1: updatedMessageTemplateList?.[0],
              messageTemplate2: lastTemplate,
              sampleText1: updatedMessageTemplateList?.[0]?.messageText,
              sampleText2: lastTemplate?.messageText,
            });
          }
        }
      });
  }

  getTollFreeNumberList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(TwilioNumberList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let tollFreeNumberList = output.data.numberList;
          let getPermission = Utils.getRolePermission(["*"]);
          let getCreatePermission = getPermission[1];

          let tollfreeNumberItems = [];
          let tollFreeNumberId = "";
          let tollFreeNumber = "";
          if (tollFreeNumberList.length > 0) {
            tollfreeNumberItems.push(tollFreeNumberList[0]);
          }
          for (let i = 0; i < tollfreeNumberItems.length; i++) {
            tollFreeNumber = tollfreeNumberItems[i].phone;

            tollFreeNumberId = tollfreeNumberItems[i].id;

            if (
              Utils.equalsIgnoreCase(
                tollfreeNumberItems[i].verificationStatus,
                "Created"
              )
            ) {
              this.setState({
                showDeleteButton: true,
                showPurchaseButton: true,
                showVerificationButton: false,
                showCheckStatusButton: false,
                showErrorMessage: false,
              });
            } else if (
              Utils.equalsIgnoreCase(
                tollfreeNumberItems[i].verificationStatus,
                "TWILIO_REJECTED"
              )
            ) {
              this.setState({
                showDeleteButton: true,
                showPurchaseButton: true,
                showVerificationButton: false,
                showCheckStatusButton: false,
                showErrorMessage: true,
              });
            } else if (
              Utils.equalsIgnoreCase(
                tollfreeNumberItems[i].verificationStatus,
                "PENDING_REVIEW"
              )
            ) {
              this.setState({
                showDeleteButton: false,
                showPurchaseButton: false,
                showVerificationButton: true,
                showErrorMessage: false,
              });
            } else if (
              Utils.equalsIgnoreCase(
                tollfreeNumberItems[i].verificationStatus,
                "PENDING"
              )
            ) {
              this.setState({
                showDeleteButton: false,
                showPurchaseButton: false,
                showVerificationButton: false,
                showCheckStatusButton: true,
                showErrorMessage: false,
              });
            } else if (
              Utils.equalsIgnoreCase(
                tollfreeNumberItems[i].verificationStatus,
                "IN_REVIEW"
              )
            ) {
              this.setState({
                showDeleteButton: false,
                showPurchaseButton: false,
                showVerificationButton: true,
                showCheckStatusButton: false,
                showErrorMessage: false,
              });
            }
          }
          let showAddToTollFreeNumber = false;
          if (tollfreeNumberItems.length > 0) {
            showAddToTollFreeNumber = false;
          } else {
            showAddToTollFreeNumber = true;
          }

          this.setState({
            render: true,
            showAddToTollFreeNumber: showAddToTollFreeNumber,
            tollFreeNumberList: tollfreeNumberItems,
            initialPage: this.state.initialPage,
            tollFreeNumberId: tollFreeNumberId,
            tollfreeNumber: tollFreeNumber,
            getCreatePermission: getCreatePermission,
          });
        } else {
        }
      }
    );
  }
  getCampaignDetails() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(GetCampaigningInfo_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let campaigningInfoDetails = output.data.campaigningInfo;
          let businessUseCaseDetails = output.data.businessUseCase;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          if (campaigningInfoDetails?.graphicDocuments) {
            const {
              emailDocument,
              emailFileext,
              emailFilename,
              keywordDocument,
              keywordFileext,
              keywordFilename,
            } = campaigningInfoDetails.graphicDocuments;

            const emailUrl = emailDocument
              ? Utils.base64ToUrl(emailDocument)
              : null;
            const keywordUrl = keywordDocument
              ? Utils.base64ToUrl(keywordDocument)
              : null;
            this.setState({
              emailDocUrl: emailUrl,
              emailDocType: emailFileext?.split(".")?.pop(),
              emailDocument: emailDocument,
              emailFilename: emailFilename,
              keywordDocUrl: keywordUrl,
              keywordDocType: keywordFileext?.split(".")?.pop(),
              keywordDocument: keywordDocument,
              keywordFilename: keywordFilename,
              documentId: campaigningInfoDetails?.graphicDocuments?.id,
              open: true,
              showFileView: true,
              showLinkTextFile: false,
            });
          }
          let textToCanada = "";
          if (campaigningInfoDetails.texttocanada === true) {
            textToCanada = "Yes";
          } else {
            textToCanada = "No";
          }

          if (campaigningInfoDetails.sendMessageType) {
            this.getIndividualMsgType(campaigningInfoDetails.sendMessageType, campaigningInfoDetails, "view");
          }

          let tollfreeNumber = campaigningInfoDetails.twilioNumber !== null ? campaigningInfoDetails.twilioNumber?.phone : null;
          let tollfreeNumberStatus = campaigningInfoDetails.twilioNumber !== null ? campaigningInfoDetails.twilioNumber?.verificationStatus : null;
          store.dispatch(AppUserDataAction.setTollfreeNumber(tollfreeNumber));
          store.dispatch(AppUserDataAction.setTollfreeNumberStatus(tollfreeNumberStatus));
          this.setState({
            render: true,
            action:
              campaigningInfoDetails.sendMessageType !== null ? "view" : "edit",
            viewTwilioNumber: true,
            addTwilioNumber: false,
            id: campaigningInfoDetails.id,
            usecase: campaigningInfoDetails.usecase,
            usecaseText: campaigningInfoDetails.description,
            sampleText1: campaigningInfoDetails.sampletext1,
            sampleText2: campaigningInfoDetails.sampletext2,
            textPerMonth: campaigningInfoDetails.textpermonth,
            sendTextCanada: campaigningInfoDetails.texttocanada,
            optionPermissionLink: campaigningInfoDetails.optinpermissionlink,
            messageType: campaigningInfoDetails.sendMessageType,
            sendMessageType: campaigningInfoDetails.messageType,
            keyword: campaigningInfoDetails.keyword,
            viewSendTextCanad: textToCanada,
            // selectedFile: { name: campaigningInfoDetails?.filename },
            // optInCollectionFromAudience:
            //   campaigningInfoDetails.optinCollectionOption,
            // fileOptionLanguage: campaigningInfoDetails.fileOptinlanguage,
            // viewOptInPermissionMethod: campaigningInfoDetails?.optinPermissions,
            // tollfreeRequestSubmitted:
            //   campaigningInfoDetails.tollfreeRequestSubmitted,
            twilioNumber: campaigningInfoDetails.twilioNumber,
            businessUseCase: businessUseCaseDetails,
            // optInPermissionMethod: optInPermissionMethodList,
            // optInPermissionMethodList: optInPermissionMethodListId,

            isEmailRequest: campaigningInfoDetails.isEmailRequest,
            isOnlineForm: campaigningInfoDetails.isOnlineForm,
            onlineFormUrl: campaigningInfoDetails.onlineFormUrl,
            isOnlineCheckout: campaigningInfoDetails.isOnlineCheckout,
            onlineCheckoutUrl: campaigningInfoDetails.onlineCheckoutUrl,
            isTextKeyword: campaigningInfoDetails.isTextKeyword,

            getUpdatePermission: getUpdatePermission,
          });
        } else {
        }
      }
    );
  }

  handleUseCaseTemplateChange(selectedUseCase) {
    const sampleTexts = selectedUseCase?.sampleTexts?.filter((item) => item?.isActive) || [];
    const sampleMessageTemplate = {
      title: "I will enter my own sample below.",
      messageText: "",
      id: "sample_default",
    };

    const updatedMessageTemplateList = [
      ...sampleTexts,
      sampleMessageTemplate,
    ];
    const lastTemplate = updatedMessageTemplateList[updatedMessageTemplateList.length - 1];
    this.setState(
      {
        useCaseTemplate: selectedUseCase,
        usecase: selectedUseCase?.usecaseName,
        usecaseText: selectedUseCase?.usecaseText,
        messageTemplateList: updatedMessageTemplateList,
        messageTemplateListAll: updatedMessageTemplateList,
        messageTemplate1: updatedMessageTemplateList?.[0],
        messageTemplate2: lastTemplate,
        sampleText1: updatedMessageTemplateList?.[0]?.messageText,
        sampleText2: lastTemplate?.messageText,
      },
      () => {
        this.adjustTextareaHeight();
      }
    );
  }

  handleUsecaseTextChange(e) {
    this.setState(
      { usecaseText: e.target.value },
      () => {
        this.adjustTextareaHeight();
      }
    );
  }

  handleCampaignDescriptionChange(e) {
    this.setState({ campaignDescription: e.target.value });
  }

  handleSendMessageTypeChange(selectedType) {
    this.state.sendMessageType = selectedType;
    this.setState({
      sendMessageType: selectedType,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleMessageTemplate1Change(selectedMessage) {
    let messageTemplates = [];
    for (let i = 0; i < this.state.messageTemplateListAll.length; i++) {
      const messageTemplate = this.state.messageTemplateListAll[i];
      if (
        messageTemplate.title !== selectedMessage.title ||
        messageTemplate.id === "sample_default"
      ) {
        messageTemplates.push(messageTemplate);
      }
    }
    this.setState({
      render: true,
      messageTemplate1: selectedMessage,
      sampleText1: selectedMessage?.messageText,
      messageTemplateList: messageTemplates,
    },
      () => {
        this.adjustTextarea1Height();
      }
    );
  }
  handleMessageTemplate2Change(selectedMessage) {
    let messageTemplates = [];
    for (let i = 0; i < this.state.messageTemplateListAll.length; i++) {
      const messageTemplate = this.state.messageTemplateListAll[i];
      if (
        messageTemplate.title !== selectedMessage.title ||
        messageTemplate.id === "sample_default"
      ) {
        messageTemplates.push(messageTemplate);
      }
    }
    this.setState({
      messageTemplate2: selectedMessage,
      sampleText2: selectedMessage?.messageText,
      messageTemplateList: messageTemplates,
    },
      () => {
        this.adjustTextarea2Height();
      }
    );
  }

  handleOptInPermissionMethodChange(selectedType) {
    this.state.optInPermissionMethod = selectedType;
    let optInPermissionMethodList = [];
    for (let i = 0; i < selectedType.length; i++) {
      optInPermissionMethodList.push(selectedType[i].id);
    }
    this.setState({
      optInPermissionMethod: selectedType,
      optInPermissionMethodList: optInPermissionMethodList,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleMessageTypeListChange(selectedType) {
    this.getIndividualMsgType(selectedType);
    this.state.messageType = selectedType;
    this.setState({
      messageType: selectedType,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleTextPerMonthChange(e) {
    const { value } = e.target;
    this.setState({ textPerMonth: value });
  }
  handleSampleText1Change(e) {
    this.setState(
      { sampleText1: e.target.value },
      () => {
        this.adjustTextarea1Height();
      }
    );
  }
  handleSampleText2Change(e) {
    this.setState(
      { sampleText2: e.target.value },
      () => {
        this.adjustTextarea2Height();
      }
    );
  }

  handleSendTextCanadaChange(e) {
    const { value } = e.target;
    this.setState({ sendTextCanada: value });
  }
  handleOptionPermissionLinkChange(e) {
    this.setState({ optionPermissionLink: e.target.value });
  }
  handleOptInCollectionFromAudienceChange(selectedType) {
    this.state.optInCollectionFromAudience = selectedType;
    if (undefined === this.state.onChange) {
      this.setState({ showLinkTextFile: false, showFileView: false });
    }
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
    if (
      Utils.equalsIgnoreCase(
        selectedType?.name,
        "Insert a link to the online form that collects opt-in permission."
      )
    ) {
      this.setState({
        optInCollectionFromAudience: selectedType,
        showLinkTextFile: true,
        showFileView: false,
      });
    } else if (
      Utils.equalsIgnoreCase(
        selectedType?.name,
        "Upload a copy of a sign or graphic that shows your opt-in language"
      )
    ) {
      this.setState({
        optInCollectionFromAudience: selectedType,
        showLinkTextFile: false,
        showFileView: true,
      });
    }
  }

  handleTollFreeTypeChange(selectedValue) {
    this.state.tollFreeType = selectedValue;
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
    this.setState({ tollFreeType: selectedValue });
  }
  handleTollFreeNumberChange(selectedValue) {
    this.state.tollfreeNumber = selectedValue;
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
    this.setState({ tollfreeNumber: selectedValue });
  }
  handleClickCheckBox = (e) => {
    if (e.target.checked === "true") {
      this.setState({
        checkbox: e.target.checked,
        isDisabled: false,
      });
    } else {
      this.setState({
        checkbox: e.target.checked,
        isDisabled: true,
      });
    }
  };

  editUseCase(e) {
    this.setState(
      { action: "edit" },
      () => {
        this.adjustTextareaHeight();
        this.adjustTextarea1Height();
        this.adjustTextarea2Height();
      }
    );
  }

  updateCampaignDetailsInBackend() {
    const postObject = {
      header: this.header,
      campaigningInfo: {
        description: this.state.usecaseText,
        usecase: this.state.usecase,
        sampletext1: this.state.sampleText1,
        sampletext2: this.state.sampleText2,
        keyword: this.state.keyword,
        textpermonth: this.state.textPerMonth,
        texttocanada: this.state.sendTextCanada,
        // fileOptinlanguage: this.state.fileOptionLanguage,
        optinpermissionlink: this.state.optionPermissionLink,
        id: this.state.id,
        sendMessageType: this.state.messageType,
        messageType: this.state.sendMessageType,
        filename: this.state.fileName,

        isEmailRequest: this.state.isEmailRequest,
        isOnlineForm: this.state.isOnlineForm,
        onlineFormUrl: this.state.onlineFormUrl,
        isOnlineCheckout: this.state.isOnlineCheckout,
        onlineCheckoutUrl: this.state.onlineCheckoutUrl,
        isTextKeyword: this.state.isTextKeyword,

        // optinPermissionMethodList: this.state.optInPermissionMethodList,
        // optinCollectionOption: {
        //   id: this.state.optInCollectionFromAudience.id,
        // },
      },
    };
    FetchServerData.callPostService(UpdateCampaigningInfo_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({ action: "view", render: true });
          this.getCampaignDetails();
        } else {
        }
      })
      .catch((error) => { });
  }

  submitCampaignInfoInBackend() {
    const postObject = {
      header: this.header,
      campaigningInfo: {
        description: this.state.usecaseText,
        usecase: this.state.usecase,
        sampletext1: this.state.sampleText1,
        sampletext2: this.state.sampleText2,
        keyword: this.state.keyword,
        textpermonth: this.state.textPerMonth,
        texttocanada: this.state.sendTextCanada,
        // fileOptinlanguage: this.state.fileOptionLanguage,
        optinpermissionlink: this.state.optionPermissionLink,
        id: this.state.id,
        sendMessageType: this.state.messageType,
        messageType: this.state.sendMessageType,
        filename: this.state.fileName,
        isEmailRequest: this.state.isEmailRequest,
        isOnlineForm: this.state.isOnlineForm,
        onlineFormUrl: this.state.onlineFormUrl,
        isOnlineCheckout: this.state.isOnlineCheckout,
        onlineCheckoutUrl: this.state.onlineCheckoutUrl,
        isTextKeyword: this.state.isTextKeyword,
      },
    };

    FetchServerData.callPostService("/campaigningInfoms/submit", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({ action: "view", render: true });
          this.getCampaignDetails();
        } else {
        }
      })
      .catch((error) => { });
  }

  resubmitCampaignInfoInBackend() {
    const postObject = {
      header: this.header,
      campaigningInfo: {
        description: this.state.usecaseText,
        usecase: this.state.usecase,
        sampletext1: this.state.sampleText1,
        sampletext2: this.state.sampleText2,
        keyword: this.state.keyword,
        textpermonth: this.state.textPerMonth,
        texttocanada: this.state.sendTextCanada,
        // fileOptinlanguage: this.state.fileOptionLanguage,
        optinpermissionlink: this.state.optionPermissionLink,
        id: this.state.id,
        sendMessageType: this.state.messageType,
        messageType: this.state.sendMessageType,
        filename: this.state.fileName,
        isEmailRequest: this.state.isEmailRequest,
        isOnlineForm: this.state.isOnlineForm,
        onlineFormUrl: this.state.onlineFormUrl,
        isOnlineCheckout: this.state.isOnlineCheckout,
        onlineCheckoutUrl: this.state.onlineCheckoutUrl,
        isTextKeyword: this.state.isTextKeyword,
      },
    };

    FetchServerData.callPostService(
      "/campaigningInfoms/resubmitTollfreeRequest",
      postObject
    )
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({ action: "view", render: true });
          this.getCampaignDetails();
        } else {
        }
      })
      .catch((error) => { });
  }

  optinFileHandler(e) {
    let file = e.target.files[0];
    let reader = new FileReader();
    this.setState({
      selectedFile: e.target.files[0],
      responseArray: [],
    });
    reader.onload = (e) => {
      let file = e.target.result;
      let file1 = file.split(",");
      this.setFile = file1[1];

      const formData = new FormData();

      formData.append(
        "file",
        this.state.selectedFile,
        this.state.selectedFile.name
      );
      formData.append("sessionid", this.header.sessionid);
      formData.append("userid", this.header.userid);
      formData.append("adid", this.props.advertisementId);
      formData.append("isAp", this.header.isAp);
      formData.append("appclient", "W");

      this.setState({ fileOptionLanguage: this.setFile });
    };
    reader.readAsDataURL(file);
  }

  onUploadEmailScreenshotDoc(event) {
    const file = event.target.files[0];
    if (!file) return;
    const allowedExtensions = ["png", "jpg", "jpeg", "pdf", "heic"];

    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.split(".").pop();

    if (!allowedExtensions.includes(fileExtension)) {
      PtsAlert.error(
        "Invalid file type. Please upload PNG, JPG, JPEG, PDF, or HEIC files only."
      );
      event.target.value = "";
      return;
    }

    this.setState(
      {
        selectedFile: file,
      },
      () => this.uploadEmailScreenshotDoc()
    );
  }

  uploadEmailScreenshotDoc(e) {
    if (!this.state.selectedFile) {
      PtsAlert.error("Please Select The File");
      return;
    }
    const formData = new FormData();

    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile.name
    );

    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("tid", this.header.tid);
    formData.append("isAp", this.header.isAp);
    formData.append("appclient", "W");
    FetchServerData.callPostService(
      "/campaigningInfoms/uploadEmailScreenshotDoc",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let uploadEmailDocument = output.data;
        const byteArray = new Buffer(
          uploadEmailDocument?.emailDocument?.replace(/^.+base64,/, ""),
          "base64"
        );
        const url = URL.createObjectURL(new Blob([byteArray]));

        let emailFilename = uploadEmailDocument?.emailFilename;
        let urlArr = emailFilename.split(".");
        let emailDocType = urlArr[1];
        this.setState({
          emailDocUrl: url,
          emailDocType: emailDocType,
          emailDocument: uploadEmailDocument.emailDocument,
          emailFilename: emailFilename,
          emailDocumentId: uploadEmailDocument.id,
          open: true,
        });

        PtsAlert.success(output.message);
        // this.resetFile();
      } else {
      }
    });
  }

  onUploadKeywordScreenshotDoc(event) {
    const file = event.target.files[0];
    if (!file) return;

    const allowedExtensions = ["png", "jpg", "jpeg", "pdf", "heic"];

    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.split(".").pop();
    if (!allowedExtensions.includes(fileExtension)) {
      PtsAlert.error(
        "Invalid file type. Please upload PNG, JPG, JPEG, PDF, or HEIC files only."
      );
      event.target.value = "";
      return;
    }

    this.setState(
      {
        keywordSelectedFile: file,
      },
      () => this.uploadKeywordScreenshotDoc()
    );
  }

  uploadKeywordScreenshotDoc(e) {
    if (!this.state.keywordSelectedFile) {
      PtsAlert.error("Please Select The File");
      return;
    }
    const formData = new FormData();

    formData.append(
      "file",
      this.state.keywordSelectedFile,
      this.state.keywordSelectedFile.name
    );

    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("tid", this.header.tid);
    formData.append("isAp", this.header.isAp);
    formData.append("appclient", "W");
    FetchServerData.callPostService(
      "/campaigningInfoms/uploadKeywordScreenshotDoc",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let uploadKeywordDocument = output.data;
        const byteArray = new Buffer(
          uploadKeywordDocument?.keywordDocument?.replace(/^.+base64,/, ""),
          "base64"
        );
        const url = URL.createObjectURL(new Blob([byteArray]));

        let keywordFilename = uploadKeywordDocument?.keywordFilename;
        let urlArr = keywordFilename.split(".");
        let keywordDocType = urlArr[1];
        this.setState({
          keywordDocUrl: url,
          keywordDocType: keywordDocType,
          keywordDocument: uploadKeywordDocument.keywordDocument,
          keywordFilename: keywordFilename,
          keywordDocumentId: uploadKeywordDocument.id,
          open: true,
        });

        PtsAlert.success(output.message);
        // this.resetFile();
      } else {
      }
    });
  }

  deleteKeywordScreenshotDoc() {
    const postObject = {
      header: this.header,
      documentId: this.state.documentId,
    };
    FetchServerData.callPostService(
      "/campaigningInfoms/deleteKeywordScreenshotDoc",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          keywordDocUrl: null,
          keywordSelectedFile: { name: "" },
          keywordDocType: "",
          keywordFilename: "",
          keywordDocument: "",
          keywordDocumentId: "",
        });
      } else {
      }
    });
  }

  onClickCancel(e) {
    this.getCampaignDetails();
    // this.setState({ action: "view" });
  }
  resetFile() {
    document.getElementsByName("file")[0].value = null;
  }
  onClickShowEmailDoc() {
    this.setState({ showEmailDoc: true });
  }
  onClickShowKeywordDoc() {
    this.setState({ showKeywordDoc: true });
  }
  handleClose() {
    this.setState({ showEmailDoc: false, showKeywordDoc: false });
  }

  addTollFreeNumber() {
    this.setState({
      viewTwilioNumber: false,
      addTwilioNumber: true,
      showAddToTollFreeNumber: false,
    });
  }
  handleCancel() {
    this.setState({
      viewTwilioNumber: true,
      addTwilioNumber: false,
      showAddToTollFreeNumber: true,
    });
  }

  purchaseTollFreeNumberInBackend() {
    const postObject = {
      header: this.header,
      twilioNumber: {
        phone: this.state.tollfreeNumber,
      },
    };
    FetchServerData.callPostService(PurchaseTollFreeNumber_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({
            viewTwilioNumber: true,
            addTwilioNumber: false,
            showAddToTollFreeNumber: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  deleteTollFreeNumberInBackend() {
    const postObject = {
      header: this.header,
      twilioNumber: {
        phone: this.state.tollfreeNumber,
        type: "Tollfree",
        id: this.state.tollFreeNumberId,
      },
    };
    FetchServerData.callPostService(DeleteTollFreeNumber_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({
            viewTwilioNumber: true,
            addTwilioNumber: false,
            showAddToTollFreeNumber: false,
            tollFreeNumberList: [],
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  VerifyTollFreeNumber() {
    const postObject = {
      header: this.header,
      twilioNumber: {
        id: this.state.tollFreeNumberId,
      },
    };
    FetchServerData.callPostService(
      CheckTollFreePurchaseVerificationStatus_Url,
      postObject
    )
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({
            viewTwilioNumber: true,
            addTwilioNumber: false,
            showAddToTollFreeNumber: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleEmailRequestChange(e) {
    this.setState({ isEmailRequest: e.target.checked });
  }
  handleIsTextKeywordChange(e) {
    this.setState({ isTextKeyword: e.target.checked });
  }
  handleKeyWordChange(e) {
    const { value } = e.target;
    this.setState({ keyword: value });
  }

  handleIsOnlineFormChange(e) {
    this.setState({ isOnlineForm: e.target.checked });
  }
  handleOnlineFormUrlChange(e) {
    this.setState({ onlineFormUrl: e.target.value });
  }
  handleIsOnlineCheckoutChange(e) {
    this.setState({ isOnlineCheckout: e.target.checked });
  }
  handleOnlineCheckoutUrlChange(e) {
    this.setState({ onlineCheckoutUrl: e.target.value });
  }

  deleteEmailScreenshotDoc() {
    const postObject = {
      header: this.header,
      documentId: this.state.documentId,
    };
    FetchServerData.callPostService(
      "/campaigningInfoms/deleteEmailScreenshotDoc",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          emailDocUrl: null,
          emailSelectedFile: { name: "" },
          emailDocType: "",
          emailFilename: "",
          emailDocument: "",
          emailDocumentId: "",
        });
      } else {
      }
    });
  }
  showEmailDocument = () => {
    return (
      <Dialog
        open={this.state.showEmailDoc}
        onClose={this.handleClose.bind(this)}
        maxWidth="xxl"
        className="salesDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>Email Document</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            md={12}
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
              textAlign: "center",
            }}
          >
            {this.state.emailDocType === "txt" ? (
              <iframe
                src={this.state.emailDocUrl}
                style={{ width: "100%", height: "100%" }}
              />
            ) : (
              <div style={{ height: "100%" }}>
                <FileViewer
                  fileType={this.state.emailDocType}
                  filePath={this.state.emailDocUrl}
                  onError={this.onError}
                  height={800}
                />
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  };
  showKeywordDocument = () => {
    return (
      <Dialog
        open={this.state.showKeywordDoc}
        onClose={this.handleClose.bind(this)}
        maxWidth="xxl"
        className="salesDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>Keyword Document</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            md={12}
            style={{
              width: "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
              textAlign: "center",
            }}
          >
            {this.state.keywordDocType === "txt" ? (
              <iframe
                src={this.state.keywordDocUrl}
                style={{ width: "100%", height: "100%" }}
              />
            ) : (
              <div style={{ height: "100%" }}>
                <FileViewer
                  fileType={this.state.keywordDocType}
                  filePath={this.state.keywordDocUrl}
                  onError={this.onError}
                  height={800}
                />
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  newTextingNumberPurchaseRequest() {
    const postObject = {
      header: this.header,
      campaigningInfo: {
        description: this.state.usecaseText,
        usecase: this.state.usecase,
        sampletext1: this.state.sampleText1,
        sampletext2: this.state.sampleText2,
        keyword: this.state.keyword,
        textpermonth: this.state.textPerMonth,
        texttocanada: this.state.sendTextCanada,
        // fileOptinlanguage: this.state.fileOptionLanguage,
        optinpermissionlink: this.state.optionPermissionLink,
        id: this.state.id,
        sendMessageType: this.state.messageType,
        messageType: this.state.sendMessageType,
        filename: this.state.fileName,
        isEmailRequest: this.state.isEmailRequest,
        isOnlineForm: this.state.isOnlineForm,
        onlineFormUrl: this.state.onlineFormUrl,
        isOnlineCheckout: this.state.isOnlineCheckout,
        onlineCheckoutUrl: this.state.onlineCheckoutUrl,
        isTextKeyword: this.state.isTextKeyword,
      },
    };
    FetchServerData.callPostService("/campaigningInfoms/repurchase", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({ action: "view", render: true });
          this.getCampaignDetails();
        } else {
        }
      })
      .catch((error) => { });
  }

  componentDidMount() {
    this.adjustTextareaHeight();
    this.adjustTextarea1Height();
    this.adjustTextarea2Height();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.usecaseText !== this.state.usecaseText) {
      this.adjustTextareaHeight();
    }
    if (prevState.sampleText1 !== this.state.sampleText1) {
      this.adjustTextarea1Height();
    }
    if (prevState.sampleText2 !== this.state.sampleText2) {
      this.adjustTextarea2Height();
    }
  }


  adjustTextareaHeight = () => {
    if (this.textareaRef.current) {
      this.textareaRef.current.style.height = "auto"; // Reset height
      this.textareaRef.current.style.height =
        this.textareaRef.current.scrollHeight + "px"; // Set new height
    }
  };

  adjustTextarea1Height = () => {
    if (this.textareaRef1.current) {
      this.textareaRef1.current.style.height = "auto"; // Reset height
      this.textareaRef1.current.style.height =
        this.textareaRef1.current.scrollHeight + "px"; // Set new height
    }
  };
  adjustTextarea2Height = () => {
    if (this.textareaRef2.current) {
      this.textareaRef2.current.style.height = "auto"; // Reset height
      this.textareaRef2.current.style.height =
        this.textareaRef2.current.scrollHeight + "px"; // Set new height
    }
  };

  render() {
    this.emailDocUploadRef = React.createRef();
    this.keywordDocUploadRef = React.createRef();
    this.textareaRef = React.createRef();
    this.textareaRef1 = React.createRef();
    this.textareaRef2 = React.createRef();

    if (this.state.action === "edit") {
      return this.editCampaignDetails();
    } else if (this.state.action === "view") {
      return this.viewCampaignDetails();
    }
  }
  viewCampaignDetails() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <div className="row" style={{ padding: "0em 0em" }}>
            <div className="col-md-8">
              <div
                className="card"
                id="giveBeeCardTopBoxShadowremove"
                style={{ borderRadius: "0rem 0.5rem 0.5rem 0.5rem" }}
              >
                <div className="row">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="useCaseCardHeader"
                  >
                    <div className="row" style={{ width: "100%" }}>
                      <div className="col-md-10">
                        <h6 style={{ color: "#353538" }} id="headerLabel">
                          {(
                            !Utils.equalsIgnoreCase(
                              this.state.twilioNumber?.verificationStatus,
                              "Approved"
                            ) &&
                            !Utils.equalsIgnoreCase(
                              this.state.twilioNumber?.verificationStatus,
                              "Verified"
                            )
                          ) ? (
                            <span>
                              {this.state.twilioNumber === null ? "Please submit this form to get your texting number verified." : "These are the details used to verify your texting number."}
                            </span>
                          ) : (
                            <span>
                              These details were submitted to carriers for
                              verification of your texting account.
                            </span>
                          )}
                        </h6>
                      </div>
                      <div className="col-md-2">
                        {(
                          !Utils.equalsIgnoreCase(
                            this.state.twilioNumber?.verificationStatus,
                            "Approved"
                          ) &&
                          !Utils.equalsIgnoreCase(
                            this.state.twilioNumber?.verificationStatus,
                            "Verified"
                          ) &&
                          !Utils.equalsIgnoreCase(
                            this.state.twilioNumber?.verificationStatus,
                            "Pending"
                          )
                        ) && (
                            <Button
                              type={this.state.type ? this.state.type : ""}
                              variant="contained"
                              size="small"
                              style={{
                                background: "#d3d8de",
                                color: "#353538",
                                float: "right",
                                textTransform: "capitalize"
                              }}
                              startIcon={<EditIcon />}
                              onClick={this.editUseCase.bind(this)}
                            >
                              Edit
                            </Button>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row" style={{ marginTop: "1em" }}>
                      <div className="col-md-12">
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-email"
                            id="assetFormLabel"
                          >
                            Use Case
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.usecase}</span>
                          </div>
                        </div>
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-supplierType"
                            id="assetFormLabel"
                          >
                            Use Case Description
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.usecaseText}</span>
                          </div>
                        </div>
                        {/* <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Message Type
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.sendMessageType?.type}</span>
                          </div>
                        </div> */}
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Message Category
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.messageType?.description}</span>
                          </div>
                        </div>
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Texts per month
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{Utils.formatWithCommas(this.state.textPerMonth)}</span>
                          </div>
                        </div>
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Texts to Canada
                          </label>

                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.viewSendTextCanad}</span>
                          </div>
                        </div>
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Sample Text
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.sampleText1}</span>
                          </div>
                        </div>
                        {/* <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Sample Text 2
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.sampleText2}</span>
                          </div>
                        </div> */}
                        {this.state.isOnlineCheckout && (
                          <div className="row">
                            <label
                              className="col-sm-3 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Online Checkout
                            </label>
                            <div className="col-sm-9" id="givbeeText">
                              <span>{this.state.onlineCheckoutUrl}</span>
                            </div>
                          </div>
                        )}
                        {this.state.isOnlineForm && (
                          <div className="row">
                            <label
                              className="col-sm-3 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Online form
                            </label>
                            <div className="col-sm-9" id="givbeeText">
                              <span>{this.state.onlineFormUrl}</span>
                            </div>
                          </div>
                        )}
                        {this.state.isTextKeyword && (
                          <div className="row">
                            <label
                              className="col-sm-3 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Opt-in Keyword
                            </label>
                            <div className="col-sm-9" id="givbeeText">
                              <span>{this.state.keyword}</span>
                              {this.state.keywordDocUrl && (
                                <span
                                  className="anchortag ps-2"
                                  onClick={(e) => this.onClickShowKeywordDoc()}
                                >
                                  View Keyword doc
                                </span>
                              )}
                            </div>
                          </div>
                        )}
                        {this.state.emailDocUrl && (
                          <>
                            <div className="row mt-2">
                              <label
                                className="col-sm-3 col-form-label fw-bold"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Opt-in language sign/graphic
                              </label>
                              <div className="col-sm-9" id="givbeeText">
                                <span
                                  className="anchortag"
                                  onClick={(e) => this.onClickShowEmailDoc()}
                                >
                                  View Email doc
                                </span>
                              </div>
                            </div>
                          </>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="col-md-4">
              <div className="card" id="giveBeeCardTopBoxShadowremove">
                {/* {this.state.tollFreeNumberList.length > 0 ? ( */}
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className="card-header d-flex align-items-center justify-content-between p-3"
                      id="useCaseCardHeader"
                    >
                      <div className="row" style={{ width: "100%" }}>
                        <div className="col-md-12">
                          <h6 style={{ color: "#353538" }} id="headerLabel">
                            Texting Number
                          </h6>
                        </div>
                      </div>
                    </div>

                    <>
                      {this.state.twilioNumber !== null ? (
                        <>
                          <div className="card-body p-3 d-flex flex-column" style={{ height: "120%" }}>
                            <div className="row" style={{ minHeight: "215px" }}>
                              <div className="col-md-12">
                                <div className="row">
                                  <label
                                    className="col-sm-3 col-form-label fw-bold"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    Number
                                  </label>
                                  <div className="col-sm-9" id="givbeeText">
                                    <span>
                                      {this.state.twilioNumber !== null
                                        ? Utils.viewTollFreeNumberFormate(
                                          this.state.twilioNumber?.phone
                                        ).slice(-12)
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                                <div className="row">
                                  <label
                                    className="col-sm-3 col-form-label fw-bold"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    Status
                                  </label>
                                  <div className="col-sm-9" id="givbeeText">
                                    <span>
                                      {
                                        this.state.twilioNumber?.verificationStatus?.toLowerCase() === "rejected" ? (
                                          <span style={{ color: "#990000" }}>
                                            Number unverified - Application rejected.
                                          </span>
                                        ) : (
                                          this.state.twilioNumber?.verificationStatus?.toLowerCase() === "unverified"
                                            ? "Unverified"
                                            : this.state.twilioNumber?.verificationStatus ?? ""
                                        )
                                      }
                                    </span>
                                  </div>
                                </div>
                                {this.state.twilioNumber?.error !== null && (
                                  <div className="row">
                                    <label
                                      className="col-sm-3 col-form-label fw-bold"
                                      htmlFor="basic-default-name"
                                      id="assetFormLabel"
                                    >
                                      Error
                                    </label>
                                    <div className="col-sm-9" id="givbeeText">
                                      <span
                                        style={{
                                          textAlign: "justify",
                                          color: "#990000",
                                        }}
                                      >
                                        {this.state.twilioNumber
                                          ? this.state.twilioNumber?.error
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {this.state.twilioNumber?.verificationStatus?.toLowerCase() ===
                                  "rejected" && (
                                    <div className="row mt-3">
                                      <label
                                        className="col-sm-3 col-form-label fw-bold"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      ></label>
                                      <div className="col-sm-9" id="givbeeText">
                                        <span style={{ textAlign: "justify", color: "#990000" }}>
                                          Please edit Company Details or Use Case depending on error message.
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                {/* <div className="row mt-2">
                                  <label
                                    className="col-sm-3 col-form-label fw-bold"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  ></label>
                                  <div
                                    className="col-sm-9 pe-0"
                                    id="givbeeText"
                                  >
                                    <span style={{ textAlign: "justify" }}>
                                      {this.state.twilioNumber !== null &&
                                        this.state.twilioNumber?.canSubmit ===
                                        true && (
                                          <Button
                                            type="button"
                                            variant="contained"
                                            size="small"
                                            className="submitButton"
                                            style={{
                                              background: "#37517e",
                                              color: "white",
                                              marginRight: "0em",
                                              cursor: "pointer",
                                              padding: "2px 10px",
                                              textTransform: "capitalize",
                                            }}
                                            startIcon={
                                              <i
                                                class="fa fa-paper-plane"
                                                style={{ fontSize: "small" }}
                                                aria-hidden="true"
                                              ></i>
                                            }
                                            onClick={this.resubmitCampaignInfoInBackend.bind(
                                              this
                                            )}
                                          >
                                            Resubmit
                                          </Button>
                                        )}
                                      {this.state.twilioNumber
                                        ?.canPurchaseNewNumber && (
                                          <Button
                                            type="button"
                                            variant="contained"
                                            size="small"
                                            className="newTextingNumberPurchaseRequest"
                                            style={{
                                              background: "#37517e",
                                              color: "white",
                                              cursor: "pointer",
                                              padding: "2px 10px",
                                              textTransform: "capitalize",
                                            }}
                                            startIcon={
                                              <i
                                                class="fa fa-paper-plane"
                                                style={{ fontSize: "small" }}
                                                aria-hidden="true"
                                              ></i>
                                            }
                                            onClick={this.newTextingNumberPurchaseRequest.bind(
                                              this
                                            )}
                                          >
                                            New texting number Purchase Request
                                          </Button>
                                        )}
                                    </span>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            {!Utils.equalsIgnoreCase(
                              this.state.twilioNumber?.verificationStatus,
                              "Approved"
                            ) &&
                              !Utils.equalsIgnoreCase(
                                this.state.twilioNumber?.verificationStatus,
                                "Verified"
                              ) &&
                              <div className="row align-items-end">
                                <div className="col-sm-12" id="givbeeText">
                                  Having trouble? Contact
                                  {this.crmIntegration === BUSINESS_DOMAIN.dpText ?
                                    <a
                                      className="anchortag ms-1"
                                      href={`mailto: support@dptext.org`}
                                      rel="noopener noreferrer"
                                    >
                                      support@dptext.org.
                                    </a>
                                    :
                                    <a
                                      className="anchortag ms-1"
                                      href={`mailto: support@givbee.com`}
                                      rel="noopener noreferrer"
                                    >
                                      support@givbee.com.
                                    </a>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </>
                      ) :
                        <>
                          <div className="card-body p-3 d-flex flex-column" style={{ height: "120%" }}>
                            <div className="row" style={{ minHeight: "215px" }}>
                              <div className="col-md-12">
                                <p style={{ color: "#353538", fontSize: "14px" }}>Click Edit to complete and submit Use Case details for verification</p>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div >
          {this.showEmailDocument()}
          {this.showKeywordDocument()}
        </>
      );
    }
  }
  editCampaignDetails() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <ValidatorForm
            ref="form"
            id="multiStepsForm"
            onSubmit={this.updateCampaignDetailsInBackend.bind(this)}
          >
            <div id="useCaseDetailsValidation" className="row">
              <div className="col-md-12">
                <div
                  className="card "
                  id="giveBeeCardTopBoxShadowremove"
                  style={{ borderRadius: "0rem 0.5rem 0.5rem 0.5rem" }}
                >
                  <div
                    className="card-header d-flex align-items-center justify-content-between p-2"
                    id="assetCardHeader"
                  >
                    <div className="col-md-6">
                      <h6 className="mb-0" id="headerLabel">
                        These are the details used to verify your texting number.
                      </h6>
                    </div>
                    <div className="col-md-6 text-end">
                      {(
                        !this.state.twilioNumber ||
                        (
                          !Utils.equalsIgnoreCase(this.state.twilioNumber?.verificationStatus, "Approved") &&
                          !Utils.equalsIgnoreCase(this.state.twilioNumber?.verificationStatus, "Verified")
                        )
                      ) && (
                          <Button
                            type="button"
                            variant="contained"
                            size="small"
                            className="submitButton"
                            disabled={this.state.twilioNumber?.verificationStatus?.toLowerCase() === "pending"}
                            style={{
                              background: "green",
                              color: "white",
                              textTransform: "none",
                              marginRight: "0px",
                            }}
                            onClick={this.submitCampaignInfoInBackend.bind(this)}
                          >
                            {this.state.twilioNumber !== null ? "Resubmit for verification" : "Submit for verification"}
                          </Button>
                        )}
                    </div>
                  </div>
                  <div className="card-body p-2">
                    <div className="col-md-12">
                      <div className="row">
                        <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                          Before you can start sending text messages, AT&T and
                          Verizon require some details about your use case and
                          opt-in process. Once they’ve reviewed your answers,
                          your new phone number will be verified for texting.
                        </p>
                        <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                          <b>
                            Please submit this form as soon as possible to start
                            the approval process.
                          </b>
                        </p>
                      </div>
                      <hr></hr>
                      <div className="row">
                        <div className="col-sm-4">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            Which of these best represents your business type?*
                          </label>
                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            ListboxProps={{
                              className: "custom-listbox",
                            }}
                            options={this.state.messageTypes}
                            value={this.state.messageType}
                            getOptionLabel={(option) => option.description}
                            defaultValue={this.state.messageType}
                            onChange={(event, value) => {
                              this.handleMessageTypeListChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="textField"
                                required
                                title=""
                                style={{ background: "#fff" }}
                              />
                            )}
                          />
                        </div>
                        <div className="col-sm-4">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            Max number of text you'll likely send in a month.*
                          </label>
                          <select
                            title=""
                            required
                            id="multiStepsState"
                            className="select2 form-select"
                            style={{ width: "120px" }}
                            data-allow-clear="true"
                            value={this.state.textPerMonth}
                            onChange={this.handleTextPerMonthChange.bind(this)}
                          >
                            <option value="">Select</option>
                            <option value="10">10</option>
                            <option value="100">100</option>
                            <option value="1000">1,000</option>
                            <option value="3000">3,000</option>
                            <option value="10000">10,000</option>
                          </select>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-4">
                          <div className="row">
                            <div className="col-sm-12">
                              {" "}
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Messaging use case categories
                              </label>
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.state.useCaseList}
                                value={this.state.useCaseTemplate}
                                getOptionLabel={(option) => option.usecaseName}
                                defaultValue={this.state.useCaseTemplate}
                                onChange={(event, value) => {
                                  this.handleUseCaseTemplateChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="textField"
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-12 mt-2">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Use case description*
                              </label>
                              <textarea
                                ref={this.textareaRef}
                                title=""
                                required
                                value={this.state.usecaseText}
                                onChange={this.handleUsecaseTextChange.bind(
                                  this
                                )}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                // rows="3"
                                style={{
                                  overflow: "hidden",
                                  resize: "vertical",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            Will you be texting people in Canada?*
                          </label>
                          <select
                            title=""
                            required
                            id="multiStepsState"
                            className="select2 form-select"
                            style={{ width: "120px" }}
                            data-allow-clear="true"
                            value={this.state.sendTextCanada}
                            onChange={this.handleSendTextCanadaChange.bind(
                              this
                            )}
                          >
                            <option value="">Select</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                      </div>
                      {/* <div className="row mt-2">
                        <div className="col-sm-4">
                          <div className="row">
                            <div className="col-sm-12">
                              {" "}
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Use case
                              </label>
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.state.useCaseList}
                                value={this.state.useCaseTemplate}
                                getOptionLabel={(option) => option.usecaseName}
                                defaultValue={this.state.useCaseTemplate}
                                onChange={(event, value) => {
                                  this.handleUseCaseTemplateChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="textField"
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-12 mt-2">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Use case Description*
                              </label>
                              <textarea
                                ref={this.textareaRef}
                                title=""
                                required
                                value={this.state.usecaseText}
                                onChange={this.handleUsecaseTextChange.bind(
                                  this
                                )}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                // rows="3"
                                style={{
                                  overflow: "hidden",
                                  resize: "vertical",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      
                      </div> */}
                      <div className="row mt-2">
                        <div className="col-sm-4">
                          <div className="row">
                            <div className="col-sm-12">
                              {" "}
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Sample text message
                              </label>
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.state.messageTemplateList}
                                value={this.state.messageTemplate1}
                                getOptionLabel={(option) => option.title}
                                defaultValue={this.state.messageTemplate1}
                                onChange={(event, value) => {
                                  this.handleMessageTemplate1Change(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="I will enter my own sample below"
                                    variant="outlined"
                                    size="small"
                                    className="textField"
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-12 mt-2">
                              {/* <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Sample text message 1*
                              </label> */}
                              <textarea
                                ref={this.textareaRef1}
                                title=""
                                required
                                value={this.state.sampleText1}
                                onChange={this.handleSampleText1Change.bind(
                                  this
                                )}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                // rows="3"
                                style={{
                                  overflow: "hidden",
                                  resize: "vertical",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-sm-4">
                          <div className="row">
                            <div className="col-sm-12">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="form-label"
                              >
                                Sample text message 2
                              </label>
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.state.messageTemplateList}
                                value={this.state.messageTemplate2}
                                getOptionLabel={(option) => option.title}
                                defaultValue={this.state.messageTemplate2}
                                onChange={(event, value) => {
                                  this.handleMessageTemplate2Change(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="I will enter my own sample below"
                                    variant="outlined"
                                    size="small"
                                    className="textField"
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-12 mt-2">
                              <textarea
                                ref={this.textareaRef2}
                                title=""
                                required
                                value={this.state.sampleText2}
                                onChange={this.handleSampleText2Change.bind(
                                  this
                                )}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                // rows="3"
                                style={{
                                  overflow: "hidden",
                                  resize: "vertical",
                                }}
                              />
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-4 mt-3">
                          <label
                            htmlFor="exampleFormControlTextarea1"
                            className="form-label"
                          >
                            Which of these methods will you use to collect
                            opt-in?
                          </label>
                          {/* <div
                            className="d-flex align-items-center mt-2"
                            id="assetFormLabel"
                          >
                            <div className="col-sm-3 pe-0" style={{ width: "195px" }}>
                              <span
                                className="me-1"
                                style={{ marginTop: "1px" }}
                              >
                                <input
                                  type="checkbox"
                                  id="emailrequest-checkbox"
                                  value={this.state.isEmailRequest}
                                  onChange={(e) =>
                                    this.handleEmailRequestChange(e)
                                  }
                                  checked={this.state.isEmailRequest}
                                />
                              </span>

                              <label
                                className="form-label"
                                htmlFor="emailrequest-checkbox"
                                style={{ cursor: "pointer" }}
                              >
                                Email request
                              </label>
                            </div>
                            <div className="col-sm-6 ps-2">
                              {this.state.emailDocUrl !== null ? (
                                <>
                                  <span
                                    onClick={(e) => this.onClickShowEmailDoc()}
                                    className="anchortag"
                                  >
                                    View Email doc
                                  </span>
                                  <span className="ms-2">
                                    <ClearIcon
                                      className="logoDelete"
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: "50%",
                                        border: "solid 2px",
                                        color: "#697a8d",
                                      }}
                                      onClick={this.deleteEmailScreenshotDoc.bind(
                                        this
                                      )}
                                    />
                                  </span>
                                </>
                              ) : (
                                <span className="csvFile align-self-center">
                                  <label
                                    htmlFor="email-upload"
                                    class="custom-file-upload"
                                  >
                                    Upload Email Screenshot
                                  </label>
                                  <input
                                    id="email-upload"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpeg, image/jpg, image/heic, application/pdf"
                                    style={{ margin: "0.2em" }}
                                    ref={this.emailDocUploadRef}
                                    onChange={this.onUploadEmailScreenshotDoc.bind(
                                      this
                                    )}
                                    onClick={(e) => {
                                      e.target.value = null;
                                      this.setState({
                                        imageError: "",
                                        selectedFile: { name: "" },
                                      });
                                    }}
                                  />
                                </span>
                              )}
                            </div>
                          </div> */}
                          <div
                            className="row d-flex align-items-center mt-2"
                            id="assetFormLabel"
                          >
                            <div className="col-sm-4 pe-0">
                              <span
                                className="me-1"
                                style={{ marginTop: "1px" }}
                              >
                                <input
                                  type="checkbox"
                                  id="onlineform-checkbox"
                                  value={this.state.isOnlineForm}
                                  onChange={(e) =>
                                    this.handleIsOnlineFormChange(e)
                                  }
                                  checked={this.state.isOnlineForm}
                                />
                              </span>
                              <label
                                className="form-label"
                                htmlFor="onlineform-checkbox"
                                style={{ cursor: "pointer" }}
                              >
                                Online form
                              </label>
                            </div>
                            <div className="col-sm-8">
                              <input
                                title=""
                                required={this.state.isOnlineForm === true}
                                value={this.state.onlineFormUrl}
                                onChange={this.handleOnlineFormUrlChange.bind(
                                  this
                                )}
                                type="text"
                                id="multiStepsCity"
                                className="form-control"
                                placeholder="Insert link to form that collects opt-in"
                              />
                            </div>
                          </div>
                          <div
                            className="row d-flex align-items-center mt-2"
                            id="assetFormLabel"
                          >
                            <div className="col-sm-4 pe-0">
                              <span
                                className="me-1"
                                style={{ marginTop: "1px" }}
                              >
                                <input
                                  type="checkbox"
                                  id="onlinecheckout-checkbox"
                                  value={this.state.isOnlineCheckout}
                                  onChange={(e) =>
                                    this.handleIsOnlineCheckoutChange(e)
                                  }
                                  checked={this.state.isOnlineCheckout}
                                />
                              </span>

                              <label
                                className="form-label"
                                htmlFor="onlinecheckout-checkbox"
                                style={{ cursor: "pointer" }}
                              >
                                Online checkout
                              </label>
                            </div>

                            <div className="col-sm-8">
                              <input
                                title=""
                                required={this.state.isOnlineCheckout === true}
                                value={this.state.onlineCheckoutUrl}
                                onChange={this.handleOnlineCheckoutUrlChange.bind(
                                  this
                                )}
                                type="text"
                                id="multiStepsCity"
                                className="form-control"
                                placeholder="Insert link to form that collects opt-in"
                              />
                            </div>
                          </div>
                          <div
                            className="row d-flex align-items-center mt-2"
                            id="assetFormLabel"
                          >
                            <div className="col-sm-4 pe-0">
                              <span
                                className="me-1"
                                style={{ marginTop: "1px" }}
                              >
                                <input
                                  type="checkbox"
                                  id="textakeyword-checkbox"
                                  value={this.state.isTextKeyword}
                                  onChange={(e) =>
                                    this.handleIsTextKeywordChange(e)
                                  }
                                  checked={this.state.isTextKeyword}
                                />
                              </span>

                              <label
                                className="form-label"
                                htmlFor="textakeyword-checkbox"
                                style={{ cursor: "pointer" }}
                              >
                                Keyword
                              </label>
                            </div>
                            <div className="col-sm-8">
                              <input
                                title=""
                                required={this.state.isTextKeyword === true}
                                value={this.state.keyword}
                                onChange={this.handleKeyWordChange.bind(this)}
                                type="text"
                                id="multiStepsCity"
                                className="form-control"
                                placeholder="Enter a keyword you will likely use"
                              />
                            </div>
                            <div className="col-sm-5">
                              {/* {this.state.keywordDocUrl !== null ? (
                                <>
                                  <span
                                    onClick={(e) =>
                                      this.onClickShowKeywordDoc()
                                    }
                                    className="anchortag"
                                  >
                                    View Keyword doc
                                  </span>
                                  <span className="ms-2">
                                    <ClearIcon
                                      className="logoDelete"
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: "50%",
                                        border: "solid 2px",
                                        color: "#697a8d",
                                      }}
                                      onClick={this.deleteKeywordScreenshotDoc.bind(
                                        this
                                      )}
                                    />
                                  </span>
                                </>
                              ) : (
                                <span className="csvFile align-self-center">
                                  <label
                                    htmlFor="keyword-upload"
                                    class="custom-file-upload"
                                  >
                                    Upload Keyword Screenshot
                                  </label>
                                  <input
                                    id="keyword-upload"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpeg, image/jpg, image/heic, application/pdf"
                                    style={{ margin: "0.2em" }}
                                    ref={this.keywordDocUploadRef}
                                    onChange={this.onUploadKeywordScreenshotDoc.bind(
                                      this
                                    )}
                                    onClick={(e) => {
                                      e.target.value = null;
                                      this.setState({
                                        imageError: "",
                                        keywordSelectedFile: { name: "" },
                                      });
                                    }}
                                  />
                                </span>
                              )} */}
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-sm-4 mt-3">
                          <div className="row">
                            <label
                              htmlFor="exampleFormControlTextarea1"
                              className="form-label mb-3"
                            >
                              Opt-in language sign/graphic
                            </label>
                            {!this.state.emailDocUrl && (
                              <span className="csvFile align-self-center">
                                <label
                                  htmlFor="file-upload"
                                  class="custom-file-upload"
                                >
                                  Upload Email Screenshot
                                </label>
                                <input
                                  id="file-upload"
                                  type="file"
                                  name="file"
                                  inputlabelprops={{
                                    shrink: true,
                                    style: {},
                                  }}
                                  style={{ margin: "0.2em" }}
                                  ref={this.fileUploadRef}
                                  onChange={this.onUploadEmailScreenshotDoc.bind(
                                    this
                                  )}
                                  onClick={(e) => {
                                    e.target.value = null;
                                    this.setState({
                                      imageError: "",
                                      selectedFile: { name: "" },
                                    });
                                  }}
                                />
                              </span>
                            )}
                            {this.state.emailDocUrl && (
                              <>
                                <div className="col-sm-8 pe-0 d-flex">
                                  <img
                                    style={{
                                      // width: "-webkit-fill-available",
                                      height: "10em",
                                      objectFit: "contain",
                                      objectPosition: "left",
                                    }}
                                    alt=""
                                    src={
                                      this.state.emailDocUrl
                                        ? this.state.emailDocUrl
                                        : ""
                                    }
                                  />
                                  <span className="fw-bold ms-2">
                                    <ClearIcon
                                      className="logoDelete"
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: "50%",
                                        border: "solid 2px",
                                      }}
                                      onClick={this.deleteEmailScreenshotDoc.bind(
                                        this
                                      )}
                                    />
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3 align-items-center">
              <div className="col-sm-4"></div>
              <div className="col-sm-4 text-center">
                <Button
                  type="submit"
                  variant="contained"
                  className="usecaseSaveBtn"
                  startIcon={<CheckIcon style={{ fontSize: "16px" }} />}
                >
                  Save
                </Button>

                {(
                  !this.state.twilioNumber ||
                  (
                    !Utils.equalsIgnoreCase(this.state.twilioNumber?.verificationStatus, "Approved") &&
                    !Utils.equalsIgnoreCase(this.state.twilioNumber?.verificationStatus, "Verified")
                  )
                ) && (
                    <Button
                      type="button"
                      variant="contained"
                      size="small"
                      className="submitButton"
                      disabled={this.state.twilioNumber?.verificationStatus?.toLowerCase() === "pending"}
                      style={{
                        background: "green",
                        color: "white",
                        textTransform: "none",
                        marginRight: "1rem",
                      }}
                      onClick={this.submitCampaignInfoInBackend.bind(this)}
                    >
                      {this.state.twilioNumber !== null ? "Resubmit for verification" : "Submit for verification"}
                    </Button>
                  )}

                <CancelIconButton onClick={(e) => this.onClickCancel()} />
              </div>

              <div className="col-sm-4 text-end">
                {/* {(
                  !this.state.twilioNumber ||
                  (
                    !Utils.equalsIgnoreCase(this.state.twilioNumber?.verificationStatus, "Approved") &&
                    !Utils.equalsIgnoreCase(this.state.twilioNumber?.verificationStatus, "Verified")
                  )
                ) && (
                    <Button
                      type="button"
                      variant="contained"
                      size="small"
                      className="submitButton"
                      disabled={this.state.twilioNumber?.verificationStatus?.toLowerCase() === "pending"}
                      style={{
                        background: "green",
                        color: "white",
                        textTransform: "capitalize",
                      }}
                      onClick={this.submitCampaignInfoInBackend.bind(this)}
                    >
                      Submit for Verification
                    </Button>
                  )} */}
              </div>

            </div>
          </ValidatorForm>
          {this.showEmailDocument()}
          {this.showKeywordDocument()}
        </>
      );
    }
  }
}

export default withRouter(CampaignInformation);
